export {
	getTomorrowStr,
	getYesterdayStr,
	getWeekStartFromRef,
	dateFromIsoString,
	getWeekDates,
} from './date';

export {
	waypointsFromAssigned,
	geosFromAssigned,
	partitionWaypoints,
	getPartitions,
	priorityColors,
	flagColors,
} from './google';

export { guid } from './guid';

export const labVal = el => ({ label: el, value: el });
